export default class system{
    static token  = "token";
    static baseURL = process.env.VUE_APP_AJAXURL;
    static downUrl = this.baseURL+ "/api/file/fileopt/down";

}
